module.exports = __webpack_public_path__ + "media/images/illustrations/id-card-014e1a324cad5fae38cce3600e98b83f.svg";